import ContentType from '@/helpers/contentType';

import CardTopic from '../card-topic';

export default {
  props: {
    isOpen: {
      type    : Boolean,
      default : false
    },
    topic: {
      type    : Object,
      default : () => ({})
    },
    parentTopic: {
      type    : Object,
      default : () => ({})
    }
  },
  components: {
    CardTopic
  },
  watch: {
    isOpen(value) {
      if (value) {
        this.$nextTick()
          .then(() => {
            const cardTopicIconImageContainer = this.$refs.cardTopic.$el.children[0].children[0].clientHeight;
            const cardTopicWrapperInformationContainer = this.$refs.cardTopic.$el.children[0].children[1].clientHeight;

            this.height = cardTopicIconImageContainer + cardTopicWrapperInformationContainer;
          });
      } else {
        this.height = 250;
      }
    }
  },
  data() {
    return {
      height      : 250,
      hasExpanded : false
    };
  },
  methods: {
    calculateHeightOfSheet() {
      this.$nextTick()
        .then(() => {
          const cardTopicIconImageContainer = this.$refs.cardTopic.$el.children[0].children[0].clientHeight;
          const cardTopicWrapperInformationContainer = this.$refs.cardTopic.$el.children[0].children[1].clientHeight;
          const offsetWebConference = 70;

          if (this.topic.topicTypeId === ContentType.WEBCONFERENCE) {
            this.height = cardTopicIconImageContainer + cardTopicWrapperInformationContainer + offsetWebConference;
          } else {
            this.height = cardTopicIconImageContainer + cardTopicWrapperInformationContainer;
          }

          this.hasExpanded = true;
        });
    },
    close() {
      this.$emit('close');
      this.hasExpanded = false;
    }
  }
};
